import * as React from "react";
import { Collection, FieldValueCollection } from "typings/index";
import { Dialog, DialogType, PrimaryButton, DialogFooter, DefaultButton } from "office-ui-fabric-react/lib";
import styled from "styled-components";

export interface Props
{
    value: FieldValueCollection;
    placeholder?: string;
    onDismissClick: () => void;
    addOrRemoveFromCollection: (id: string) => void;
    onSave: () => void;
    selectedCollections: string[];
    collections: Collection[];
}

const DialogStyle = styled.div`
    min-height:250px;
   button{
        margin: 5px;
        border-radius: 13px;
   }
`;

const CollectionPickerDialog: React.FunctionComponent<Props> = props =>
{
   

    const addOrRemoveFromCollection = (id: string) => () =>
    {
        props.addOrRemoveFromCollection(id);
    };

    return (
        <Dialog onDismiss={props.onDismissClick} hidden={false}
            minWidth={650}
            
            dialogContentProps={{
                type: DialogType.normal,
                title: "Collection Picker",
            }}>
            <DialogStyle>
               {props.collections.map((collection, index) =>
                {
                    const btnProps = {
                        onClick: addOrRemoveFromCollection(collection.id),
                        text:collection.name
                    };
                    if (props.selectedCollections.indexOf(collection.id) > -1)
                    {
                        return <PrimaryButton key={index} iconProps={{ iconName: "CheckMark" }} {...btnProps} />;
                    }
                    return <DefaultButton key={index} {...btnProps} />;
                })}
              
            </DialogStyle>
            <DialogFooter>
                <PrimaryButton onClick={props.onSave} text="Save" />
                <DefaultButton onClick={props.onDismissClick} text="Cancel" />
            </DialogFooter>
        </Dialog>
    );
    
};

export default CollectionPickerDialog;


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/collectionPicker/CollectionPickerDialog.tsx